import logo from "../assets/images/logo.png";

import hero from "../assets/images/hero.webp";
import smartSecurity from "../assets/images/smart-security.webp";
import access from "../assets/images/access-control.webp";
import network from "../assets/images/network.webp";

import automation from "../assets/images/automation.jpg";

import project1 from "../assets/images/project1.webp";
import project2 from "../assets/images/project2.jpeg";
import project3 from "../assets/images/project3.webp";

export const SITE = {
  company: "Aerol Colt Security Systems LLC",

  shortName: "Aerol Colt",

  initials: "AC",

  phone: "+971 4 221 7745",
  phoneTel: "+97142217745",

  phoneMobile: "+971 54 414 7522",
  phoneMobileTel: "+971544147522",

  whatsapp: "971544147522",

  email: "info@aerolcoltsecuritysystems.ae",

  address:
    "R A G Global Business Hub, Office No. 111, First Floor, Shaikha Mhara – Al Qusais Building, Dubai, UAE",

  addressShort: "Al Qusais, Dubai, UAE",

  poBox: "P.O. Box 624178",

  mapsUrl:
    "https://www.google.com/maps?q=Shaikha+Mhara+Building+Al+Qusais+Dubai",

  tagline: "SIRA-Approved Security & Smart Systems",

  logo,
};

export const IMAGES = {
  hero,
  smartSecurity,
  access,
  network,
  automation,
  project1,
  project2,
  project3,
};